import type React from "react"
import { useEffect } from "react"
import styled from "styled-components"
import { captureEvent } from "~/modules/analytics/capture"
import { useTranslate } from "~/ur-react-hooks"
import { clearAuthToken } from "./util"

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;

  font-size: 3em;
`

type LogoutProps = {}

export const Logout: React.FC<LogoutProps> = () => {
  const translations = useTranslate({
    goodbye: "auth.goodbye",
  })

  useEffect(() => {
    clearAuthToken()
    captureEvent("logout")
    window.location.href = "/login"
  }, [])

  return <Wrapper>{translations.goodbye}</Wrapper>
}
